import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Text, BoldText, RegularText } from '../../common/Text';

import SymptomImg from '../../../images/consultations/case-detail.png';

const OuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin: 0.25rem 0;
`;

const Title = styled(BoldText)`
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #413958;
  padding-top: 8px;
  padding-bottom: 16px;
  border-bottom: 1px dashed #d3d6db;
`;

const SymptomContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 0.5rem 0;
`;

const SymptomIconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1.15rem;
  flex-shrink: 0;
  margin-right: 14px;
`;

const SymptomIcon = styled.img`
  width: 20px;
  height: 20px;
`;

const SymptomText = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
`;

const SymptomTagsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SymptomTag = styled(RegularText)`
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  margin: 4px 0;
`;

const CaseDetailsMessage = ({ caseDetails }) => {
  const renderSymptom = (ele, idx) => {
    const renderSymptomTag = (tag, tagIdx) => (
      <SymptomTag key={tagIdx}>{tag}</SymptomTag>
    );
    return (
      <SymptomContainer key={idx}>
        <SymptomIconContainer>
          <SymptomIcon src={SymptomImg} />
        </SymptomIconContainer>
        <SymptomTagsContainer>
          <SymptomText>{ele.title}</SymptomText>
          {ele.tags.map(renderSymptomTag)}
        </SymptomTagsContainer>
      </SymptomContainer>
    );
  };
  return (
    <OuterContainer>
      <Title>Your Case Details</Title>
      {caseDetails.map(renderSymptom)}
    </OuterContainer>
  );
};

CaseDetailsMessage.propTypes = {
  caseDetails: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      tags: PropTypes.arrayOf(PropTypes.string),
    })
  ),
};

export default CaseDetailsMessage;
